var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.6,
    height: 17,
    viewBox: "0 0 13.6 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications_FILL0_wght400_GRAD0_opsz48",
    d: "M8,18.45V17.175H9.785v-6.5a5.158,5.158,0,0,1,1.052-3.156A4.5,4.5,0,0,1,13.61,5.742V5.126a1.044,1.044,0,0,1,.351-.807,1.265,1.265,0,0,1,1.679,0,1.044,1.044,0,0,1,.351.807v.616a4.546,4.546,0,0,1,2.784,1.774,5.124,5.124,0,0,1,1.062,3.156v6.5H21.6V18.45Zm6.8-6.269ZM14.8,21a1.648,1.648,0,0,1-1.19-.5,1.62,1.62,0,0,1-.51-1.2h3.4A1.7,1.7,0,0,1,14.8,21Zm-3.74-3.825h7.5v-6.5a3.692,3.692,0,0,0-1.073-2.688A3.584,3.584,0,0,0,14.821,6.89a3.737,3.737,0,0,0-3.761,3.783Z",
    transform: "translate(-8 -4)",
    fill: "#687178"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.230e1b8db5a5829ce41f01af6bc72f86.svg";
export { ForwardRef as ReactComponent };